import Navbar from '@/components/feature/Navbar';
import ContactFooter from '@/pages/home/components/ContactFooter';
import DocumentHero from './components/DocumentHero';
import DocumentProcess from './components/DocumentProcess';
import DocumentSubmit from './components/DocumentSubmit';
import DocumentNotice from './components/DocumentNotice';

export default function DocumentPage() {
  return (
    <div className="min-h-screen w-full">
      <Navbar />
      <main>
        <DocumentHero />
        <DocumentProcess />
        <DocumentSubmit />
        <DocumentNotice />
      </main>
      <ContactFooter />
    </div>
  );
}